import React, { useEffect, useState } from 'react';
import { teacherApi, adminApi } from '../../api/client';
import Spinner from '../../components/common/Spinner';

export default function ReportCards() {
  const [learners, setLearners] = useState([]);
  const [terms,    setTerms]    = useState([]);
  const [learnerId, setLearnerId] = useState('');
  const [termId,    setTermId]    = useState('');
  const [report,    setReport]    = useState(null);
  const [loading,   setLoading]   = useState(false);

  useEffect(()=>{ adminApi.getLearners({}).then(r=>setLearners(r.data.data)); adminApi.getTerms().then(r=>setTerms(r.data.data)); },[]);

  useEffect(()=>{ if(!learnerId) return; setLoading(true); teacherApi.getReportCard({ learner_id:learnerId, ...(termId&&{term_id:termId}) }).then(r=>setReport(r.data.data)).finally(()=>setLoading(false)); },[learnerId,termId]);

  const att = report?.attendance;
  const attPct = att?.total>0 ? Math.round((att.present/att.total)*100) : null;

  return (
    <div>
      <div className="page-header"><h2>Report Cards</h2><p>View and generate learner report cards</p></div>
      <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap'}}>
        <div><label className="sms-label">Learner</label>
          <select className="sms-input" style={{width:260}} value={learnerId} onChange={e=>setLearnerId(e.target.value)}>
            <option value="">Select Learner</option>{learners.map(l=><option key={l.user_id} value={l.user_id}>{l.first_name} {l.surname} (Gr {l.grade_number})</option>)}
          </select>
        </div>
        <div><label className="sms-label">Term (optional)</label>
          <select className="sms-input" style={{width:180}} value={termId} onChange={e=>setTermId(e.target.value)}>
            <option value="">All Terms</option>{terms.map(t=><option key={t.term_id} value={t.term_id}>{t.name} {t.year}</option>)}
          </select>
        </div>
      </div>

      {!learnerId&&<div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'60px 0'}}>Select a learner to view their report card</div>}
      {learnerId&&loading&&<Spinner/>}
      {learnerId&&!loading&&report&&(
        <div>
          {att&&<div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:24}}>
            {[['Total Days',att.total,'#6b7280'],['Present',att.present,'#10b981'],['Absent',att.absent,'#ef4444'],['Attendance %',attPct!==null?`${attPct}%`:'—',attPct>=75?'#10b981':attPct>=50?'#f59e0b':'#ef4444']].map(([l,v,c])=>(
              <div key={l} style={{background:'#fff',borderRadius:12,padding:16,textAlign:'center',border:`1px solid ${c}33`}}>
                <div style={{fontSize:'1.6rem',fontWeight:700,color:c}}>{v}</div>
                <div style={{fontSize:'0.8rem',color:'#6b7280'}}>{l}</div>
              </div>
            ))}
          </div>}

          {Object.entries(report.subjects||{}).map(([sub,data])=>(
            <div key={sub} className="sms-card" style={{marginBottom:16}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
                <h5 style={{fontWeight:600,margin:0}}>{sub}</h5>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <span style={{fontSize:'1.4rem',fontWeight:700,color:data.average>=75?'#10b981':data.average>=50?'#f59e0b':'#ef4444'}}>{data.average!==null?`${data.average}%`:'—'}</span>
                  <span style={{fontSize:'1.1rem',fontWeight:700,padding:'4px 12px',borderRadius:8,background:data.average>=75?'#d1fae5':data.average>=50?'#fef3c7':'#fee2e2',color:data.average>=75?'#065f46':data.average>=50?'#92400e':'#991b1b'}}>{data.grade_symbol}</span>
                </div>
              </div>
              <table className="sms-table">
                <thead><tr><th>Assessment</th><th>Type</th><th>Score</th><th>Total</th><th>%</th><th>Comment</th></tr></thead>
                <tbody>
                  {data.assessments.map((a,i)=>{
                    const pct=a.score!==null&&a.total_marks>0?Math.round((a.score/a.total_marks)*100):null;
                    return <tr key={i}><td>{a.assessment_name}</td><td style={{textTransform:'capitalize'}}>{a.type}</td><td>{a.score??'—'}</td><td>{a.total_marks}</td><td style={{color:pct!==null?(pct>=75?'#10b981':pct>=50?'#f59e0b':'#ef4444'):'#9ca3af'}}>{pct!==null?`${pct}%`:'—'}</td><td style={{color:'#6b7280',fontSize:'0.83rem'}}>{a.comment||''}</td></tr>;
                  })}
                </tbody>
              </table>
            </div>
          ))}
          {Object.keys(report.subjects||{}).length===0&&<div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'40px 0'}}>No marks recorded for this learner</div>}
        </div>
      )}
    </div>
  );
}
